import {
  GET_VENDORS_LIST,
  GET_VENDOR,
  DELETE_VENDOR,
} from '../../actions/vendors';

export default function vendors(state = {}, action) {
  switch (action.type) {
    case GET_VENDORS_LIST:
      return Object.assign({}, state, action.payload);
    case GET_VENDOR:
      return Object.assign({}, state, action.payload);
    case DELETE_VENDOR:
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id == action.payload.id) {
          state.list.splice(i, 1);
        }
      }
      return Object.assign({}, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/vendors/index.js